import { ValidatorFn } from '@angular/forms';

export interface ValidationConfig {
  type: string;
  message: string;
  validatorFn?: ValidatorFn;
  params?: any;
}

export enum ValidationConfigType {
  Required = 'required',
  RequiredTrue = 'requiredTrue',
  MinLength = 'minLength',
  MaxLength = 'maxLength',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
}

export enum AngularValidationType {
  Required = ValidationConfigType.Required,
  RequiredTrue = ValidationConfigType.RequiredTrue,
  MinLength = 'minlength',
  MaxLength = 'maxlength',
  Email = ValidationConfigType.Email,
  PhoneValidation = 'phoneValidation',
}
